<div class="page">
  <button (click)="createNewAccessClaimsGroup()">Create new AccessClaimsGroup</button>
  <button (click)="edit()">{{ uiState === 'edit' ? 'Cancel' : 'Edit' }}</button>

  <!-- ListServiceGroup -->
  @if (uiState === 'list' || uiState === 'edit') {
    <div class="list">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col" sortable="Name">Name</th>
            <th scope="col" sortable="AccessClaimsCount">AccessClaims Count</th>
            @if (uiState === 'edit') {
              <th scope="col">Modify</th>
            }
            @if (uiState === 'edit') {
              <th scope="col">X</th>
            }
          </tr>
        </thead>
        @if (accessClaimsGroups$ | async | sortByName; as accessClaimsGroups) {
          <tbody>
            <!-- | async -->
            @for (accessClaimsGroup of accessClaimsGroups; track accessClaimsGroup) {
              <tr>
                <th scope="row">{{ accessClaimsGroup.id }}</th>
                <td>{{ accessClaimsGroup.name }}</td>
                <td>{{ accessClaimsGroup.accessClaims.length }}</td>
                <td>
                  @if (uiState === 'edit') {
                    <button class="deleteButton" (click)="modifyAccessClaimsGroup(accessClaimsGroup)">Modify</button>
                  }
                </td>
                <td>
                  @if (uiState === 'edit') {
                    <button class="deleteButton" (click)="deleteAccessClaimsGroup(accessClaimsGroup)">X</button>
                  }
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    </div>
  }

  <!-- CreateUser -->
  @if (uiState === 'create' || uiState === 'modify') {
    <div class="formDiv">
      <form class="newForm" [formGroup]="form" (ngSubmit)="onSubmit()">
        @if (form.Id) {
          <div class="activeRow ml-1">
            ID:
            <label class="formElement">{{ form.Id }}</label>
          </div>
        }
        <input class="formElement" placeholder="Name" type="text" formControlName="Name" />
        @if (accessClaims$ | async | sortByValue; as accessClaims) {
          <ng-select
            class="select"
            [items]="accessClaims"
            [multiple]="true"
            placeholder="Select AccessClaims"
            formControlName="AccessClaims"
            >
          </ng-select>
        }
        <button type="submit" [disabled]="!form.valid">Submit</button>
        <button type="reset" (click)="cancelNewAccessClaimsGroup()">Cancel</button>
      </form>
    </div>
  }
</div>
